import firebase from 'firebase';

let firebaseConfig = {
    apiKey: "AIzaSyCSBRtqnA3aOw5nR2chSECL2mlXXU3eWH0",
    authDomain: "sewing-army.firebaseapp.com",
    databaseURL: "https://sewing-army.firebaseio.com",
    projectId: "sewing-army",
    storageBucket: "sewing-army.appspot.com",
    messagingSenderId: "736002247519",
    appId: "1:736002247519:web:163e008cb64ea00e5084ea"
};

const fire = firebase.initializeApp(firebaseConfig);

export default fire;






// signup() {

//     let error = false;
//     let errors = {};

//     if (!this.validateEmail(this.email)) {

//         errors['email'] = {
//             error: true,
//             message: 'Email incorrect format'
//         }
//         error = true;
//     }

//     if (this.password.length < 6) {

//         errors['password'] = {
//             error: true,
//             message: 'Password must be more than 6 characters'
//         }
//         error = true;


//     }


//     if (this.password != this.passwordConfirm) {

//         errors['passwordConfirm'] = {
//             error: true,
//             message: 'Password do not match'
//         }
//         error = true;

//     }
//     if (error) {
//         this.errors = { ...this.errors, ...errors };

//         return;
//     }


//     fire.auth().createUserWithEmailAndPassword(this.state.email, this.state.password)
//         .then((user) => {

//         })
//         .catch((err) => {
//         });
// }
// validateEmail(email) {
//     var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//     return re.test(String(email).toLowerCase());
// }

// function getFireIdToken() {
//     return fire.auth().currentUser.getIdToken();
// }

// export function sampleRequestWithToken() {

//     return fire.auth().onAuthStateChanged(function (user) {
//         getFireIdToken().then((idToken) => {
//             if (!idToken) return;
//             axios.defaults.headers.common['Authorization'] = idToken;
//             const url = '/api/endpoint';
//             return axios({
//                 method: 'put',
//                 url: url,
//                 headers: { 'Authorization': idToken },
//                 data: {
//                     someData: 'somedata'
//                 }
//             });
//         }).then((res) => {

//         });
//     });

// }